import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {Header, Grid} from 'semantic-ui-react';
import {calculateChildrenTotalByMode} from 'common/requestDetails/utils';
import {
  safeAddReduce,
  showDollarAmountWithDollar,
  safeMult,
  safeDivide,
  safeAdd,
  safeSubstract,
} from 'common/utils';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {TextAreaField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {RadioField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {ACTUAL_TOTAL, BOCS} from 'common/requestDetails/constants.js';
import {Alert} from 'componentLibrary';
import {BudgetUtils} from 'app-ui-componentlibrary/dist/go/components/common/BudgetUtils';
import {FUNDING_STREAM_NAME} from 'common/requestDetails/constants.js';

const bocs = BOCS;
const fedShare = 'fedShare';
const appShare = 'appShare';
const ALLOWED_EXCESS_TOTAL = 'allowedExcessTotal';
const SCOPE_OF_WORK_TOTAL = 'scopeOfWorkTotal';

class DynamicCostShare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      justification: '',
      alternateCostShare: '',
      costShareSummary: [],
      isLoaded: false,
    };
  }

  componentDidMount() {
    if (this.props.foConfig && this.props.fo) {
      this.initializeCostShareData();
    }
    if (this.props.entityType === 'awardRecommendation') {
      this.getNeedsAttention();
    }
  }

  initializeCostShareData() {
    const {
      costShare,
      budget,
      fo,
      entityDataPath,
      entityType,
      closeoutEntityType,
      validationId,
      saveEntityData,
    } = this.props;
    const sameForAllRecipients = _.get(fo, 'configData.costShare.sameForAllRecipients');

    if (!_.isEmpty(costShare)) {
      //Is the question do you qualify alternate cost share displayed?
      this.setState({
        justification: _.isEqual(costShare.alternateCostShare, 'Yes')
          ? costShare.justification
          : undefined,
        alternateCostShare: costShare.alternateCostShare,
      });
      if (_.isEqual(costShare.alternateCostShare, 'Yes')) {
        //when question answered Yes, displays for view/edit
        let costShareObj = {
          fedShare: !_.isEmpty(budget.share.actualAllowedFedShare)
            ? budget.share.actualAllowedFedShare
            : !_.isEmpty(budget.share.actualFedShare)
            ? budget.share.actualFedShare
            : budget.share.fedShare,
          appShare: !_.isEmpty(budget.share.actualAllowedAppShare)
            ? budget.share.actualAllowedAppShare
            : !_.isEmpty(budget.share.actualAppShare)
            ? budget.share.actualAppShare
            : budget.share.appShare,
          totals: _.map(budget.share.totals, (total) => parseFloat(total.toFixed(2))),
        };
        const costShareSumArray = [costShareObj];
        this.setState({
          costShareSummary: costShareSumArray,
        });
      } else {
        //when question answered No, displays for view
        this.calcDefaultValues();
      }
    } else if (sameForAllRecipients) {
      //when question is not displayed(not editable), displays for view and edit
      this.calcDefaultValues();
    } else {
      //intially loads the component with question answered No, only displays for edit
      this.setState({
        alternateCostShare: 'No',
      });
      this.props.saveEntityData(
        `${entityDataPath}.alternateCostShare`,
        entityType,
        'No',
        validationId
      );
      this.calcDefaultValues();
    }
    this.setState({
      isLoaded: true,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      _.isEmpty(this.state.costShareSummary) &&
      !this.state.isLoaded &&
      this.props.foConfig &&
      this.props.fo
    ) {
      this.initializeCostShareData();
    } else {
      if (
        !_.isEqual(prevState.alternateCostShare, this.state.alternateCostShare) &&
        this.state.alternateCostShare === 'No' &&
        !this.props.readOnly
      ) {
        //when question is No and not readOnly and question changed
        this.calcDefaultValues(
          this.isCloseout(this.props.entityType, this.props.closeoutEntityType)
        );
      } else if (
        !_.isEqual(prevState.alternateCostShare, this.state.alternateCostShare) &&
        this.state.alternateCostShare === 'Yes' &&
        !this.props.readOnly
      ) {
        //when question is Yes and not readOnly and question changed
        this.handleBlurDollarCell();
      } else if (
        !_.isEqual(prevProps.fundingStreams, this.props.fundingStreams) &&
        this.state.alternateCostShare !== 'Yes' &&
        !this.props.readOnly
      ) {
        //when fundingStreams is changed and question is not YES
        this.calcDefaultValues(
          this.isCloseout(this.props.entityType, this.props.closeoutEntityType)
        );
      }

      if (
        this.isCloseout(this.props.entityType, this.props.closeoutEntityType) &&
        !_.isEqual(prevProps.fundingStreams, this.props.fundingStreams) &&
        this.state.alternateCostShare === 'Yes' &&
        !this.props.readOnly
      ) {
        //in closeoutMode and fundingStreams is updated and question is Yes
        _.isEqual(this.props.entityType, 'closeoutRecommendation') ||
        _.isEqual(this.props.closeoutEntityType, 'closeoutRecommendation')
          ? this.saveActualAllowedTotals()
          : this.saveActualTotals();
      }
    }
  }

  isCloseout = (entityType, closeoutEntityType) => {
    return (
      _.isEqual(entityType, 'closeoutRecommendation') ||
      _.isEqual(closeoutEntityType, 'closeoutRecommendation') ||
      _.isEqual(entityType, 'closeoutReport') ||
      _.isEqual(closeoutEntityType, 'closeoutReport')
    );
  };

  setFedShareNeeded = (alternateCostShare, currCostShare) => {
    const {entityType, closeoutEntityType, budget} = this.props;
    let greaterNewTotals = _.forEach(currCostShare.fedShare, (value, i) => {
      if (value > budget.budgetSummary.totalCharges[i]) return true;
    });

    return alternateCostShare === 'No' &&
      greaterNewTotals &&
      (_.isEqual(entityType, 'closeoutReport') ||
        _.isEqual(closeoutEntityType, 'closeoutReport'))
      ? true
      : false;
  };

  setFedShareArrayWithLimit = (
    fedShareArray,
    appShareArray,
    awardedFedShareArray,
    totalAmounts
  ) => {
    for (let i = 0; i < fedShareArray.length; i++) {
      let fedShareLimit = awardedFedShareArray[i];
      let fedShareElement = fedShareArray[i];

      if (fedShareElement > fedShareLimit) {
        fedShareArray[i] = fedShareLimit;
        appShareArray[i] = totalAmounts[i] - fedShareArray[i];
      }
    }
    return fedShareArray;
  };

  findError = (field) => {
    const {validationErrors} = this.props;
    const errs = _.get(_.get(validationErrors, 0), field);
    if (errs instanceof Array) {
      return _.find(errs, (err) => !err.isValid);
    }
    return errs;
  };

  displayError = (field) => _.get(this.findError(field), 'isValid') === false;
  errorMessage = (field) => _.get(this.findError(field), 'message');

  handleChangeJustification = (e) => {
    let justificationValue = e.target.value;
    this.setState({
      justification: justificationValue,
    });
  };

  handleAlternateCostShareChange = (e) => {
    const {
      entityDataPath,
      entityType,
      validationId,
      saveEntityData,
      clearEntityData,
      budgetPath,
      closeoutEntityType,
    } = this.props;
    const value = e.target.value;
    this.setState({
      alternateCostShare: value,
    });
    saveEntityData(
      `${entityDataPath}.alternateCostShare`,
      entityType,
      value,
      validationId
    );
    if (value === 'No') {
      this.setState({
        justification: undefined,
      });
      clearEntityData(`${entityDataPath}.justification`, entityType, validationId);
      clearEntityData(`${budgetPath}.budget.share.totals`, entityType, validationId);
      if (_.isEqual(entityType, 'closeoutRecommendation')) {
        clearEntityData(
          `${budgetPath}.budget.budgetSummary.actualAllowedTotalCharges`,
          entityType,
          validationId
        );
      }
    } else if (
      (_.isEqual(entityType, 'closeoutRecommendation') ||
        _.isEqual(closeoutEntityType, 'closeoutRecommendation')) &&
      value === 'Yes'
    ) {
      this.saveActualAllowedTotals();
    } else if (
      (_.isEqual(entityType, 'closeoutReport') ||
        _.isEqual(closeoutEntityType, 'closeoutReport')) &&
      value === 'Yes'
    ) {
      this.saveActualTotals();
    }
  };

  handleJustificationOnBlur = () => {
    const {entityDataPath, entityType, validationId, saveEntityData} = this.props;

    saveEntityData(
      `${entityDataPath}.justification`,
      entityType,
      this.state.justification,
      validationId
    );
  };

  saveActualTotals = () => {
    const {budget, budgetPath, entityType, validationId, saveEntityData} = this.props;
    let updatedBudgetSummary = _.cloneDeep(budget.budgetSummary);
    const actualTotals = this.calcActualTotals();
    updatedBudgetSummary.actualTotalCharges = actualTotals;
    saveEntityData(
      `${budgetPath}.budget.budgetSummary`,
      entityType,
      updatedBudgetSummary,
      validationId
    );
  };

  saveActualAllowedTotals = () => {
    const {budget, budgetPath, entityType, validationId, saveEntityData} = this.props;
    let updatedBudgetSummary = _.cloneDeep(budget.budgetSummary);
    const actualAllowedTotals = this.calcActualAllowedTotals();
    updatedBudgetSummary.actualAllowedTotalCharges = actualAllowedTotals;
    saveEntityData(
      `${budgetPath}.budget.budgetSummary`,
      entityType,
      updatedBudgetSummary,
      validationId
    );
  };

  convertToPercent = (value) => {
    if (_.isNumber(value)) {
      value = (value * 100).toFixed(2) + '%';
      return value;
    }
  };

  getPercentage = (remainder, target, key) => {
    const {fo} = this.props;
    const basedOn = _.get(
      fo,
      'configData.costShare.fundingStreams.default.applicantCostShareBasedOn'
    );

    if (
      remainder != null &&
      target != null &&
      target > 0 &&
      basedOn === 'totalProjectCosts'
    ) {
      return ((remainder / target) * 100).toFixed(2) + '%';
    }
    if (remainder != null && target != null && basedOn === 'federal') {
      if (key === 'fedShare' && remainder > 0) {
        return ((2 - target / remainder) * 100).toFixed(2) + '%';
      }
      if (key === 'appShare' && target > remainder) {
        return ((remainder / (target - remainder)) * 100).toFixed(2) + '%';
      }
    }
    return null;
  };

  getRateByType = (type, fundingStreamType) => {
    const {fo, foConfig} = this.props;
    const path = type === 'fedShare' ? 'fedCostShareRate' : 'applicantCostShareRate';
    let rate;

    if (_.isEmpty(fundingStreamType)) {
      rate = _.get(fo, `configData.costShare.fundingStreams.default.${path}`, '');
    } else {
      const configFundingStream = _.find(foConfig, {fundingStreamType});
      if (type === 'fedShare') {
        rate = _.map(configFundingStream.applicantCostShareRate, (value) => {
          return 1 - value;
        });
      } else {
        rate = configFundingStream.applicantCostShareRate;
      }
    }
    return rate;
  };

  getRateByCalc = (type, costShare) => {
    const {fo} = this.props;
    const basedOn = _.get(
      fo,
      'configData.costShare.fundingStreams.default.applicantCostShareBasedOn'
    );
    const path = type === 'fedShare' ? 'fedCostShareRate' : 'applicantCostShareRate';
    let rate = [];

    const totals = costShare.totals;
    const fedShares = costShare.fedShare;
    const appShares = costShare.appShare;

    if (basedOn === 'totalProjectCosts') {
      type === 'fedShare'
        ? (rate = _.map(totals, (total, i) => {
            return fedShares[i] / total;
          }))
        : (rate = _.map(totals, (total, i) => {
            return appShares[i] / total;
          }));
    } else if (basedOn === 'federal') {
      type === 'fedShare'
        ? // remainder = total - costShare.appShare[index];
          // rate.push(2 - total / remainder);
          (rate = _.map(totals, (total, i) => {
            return 2 - total / fedShares[i];
          }))
        : // remainder = total - costShare.fedShare[index];
          // rate.push(remainder / (total - remainder))
          (rate = _.map(totals, (total, i) => {
            return appShares[i] / (total - appShares[i]);
          }));
    }
    return rate;
  };

  calcDefaultValues = (saveUpdatedShare) => {
    const {budget, fo, fundingStreams, entityType, closeoutEntityType} = this.props;
    const sameForAllRecipients = _.get(fo, 'configData.costShare.sameForAllRecipients');
    const sameAcrossFundingStreams = _.get(
      fo,
      'configData.costShare.sameAcrossFundingStreams'
    );
    const constructionProgramIncome = _.get(
      budget,
      'nonFederal.constructionProgramIncome'
    );
    const awardedFedShare = budget.share.fedShare;
    const setDefaultValues = sameForAllRecipients && sameAcrossFundingStreams;
    let defaultAppShareRate, totalAmounts;
    let numPeriods = _.get(budget, 'budgetSummary.totalCharges', []).length;
    let costShareArray = [];
    let appShareArray = [];
    let fedShareArray = [];
    if (setDefaultValues || !sameForAllRecipients) {
      const applicantCostShareBasedOn = _.get(
        fo,
        'configData.costShare.fundingStreams.default.applicantCostShareBasedOn'
      );

      if (
        _.isEqual(entityType, 'closeoutRecommendation') ||
        _.isEqual(closeoutEntityType, 'closeoutRecommendation')
      ) {
        totalAmounts = this.calcActualAllowedTotals();
      } else if (
        _.isEqual(entityType, 'closeoutReport') ||
        _.isEqual(closeoutEntityType, 'closeoutReport')
      ) {
        totalAmounts = this.calcActualTotals();
      } else {
        totalAmounts = budget.budgetSummary.totalCharges;
      }

      _.forEach(totalAmounts, (total, index) => {
        if (applicantCostShareBasedOn === 'totalProjectCosts') {
          defaultAppShareRate = this.getRateByType(appShare);
          const appVal =
            numPeriods === 1
              ? _.ceil(safeMult(total, defaultAppShareRate[index]), 2)
              : _.round(safeMult(total, defaultAppShareRate[index]), 2);
          appShareArray.push(appVal);
        }
        if (applicantCostShareBasedOn === 'federal') {
          defaultAppShareRate = this.getRateByType(appShare);
          const variable = 1 + defaultAppShareRate[index];
          const appVal =
            numPeriods === 1
              ? _.ceil(
                  safeDivide(safeMult(total, defaultAppShareRate[index]), variable),
                  2
                )
              : _.round(
                  safeDivide(safeMult(total, defaultAppShareRate[index]), variable),
                  2
                );
          appShareArray.push(appVal);
        }
      });
      fedShareArray = BudgetUtils.getFedShareByAppShare(totalAmounts, appShareArray);
      if (this.isCloseout(entityType, closeoutEntityType))
        fedShareArray = this.setFedShareArrayWithLimit(
          fedShareArray,
          appShareArray,
          awardedFedShare,
          totalAmounts
        );

      let costShareObj = {
        fedShare: fedShareArray,
        appShare: appShareArray,
        totals: totalAmounts,
      };
      costShareArray.push(costShareObj);
      this.setState(
        {
          costShareSummary: costShareArray,
        },
        () => {
          if (saveUpdatedShare) this.handleBlurDollarCell();
        }
      );
    } else {
      _.forEach(fundingStreams, (fundingStream) => {
        const itemBocCharges = BudgetUtils.collectCosts(
          _.fill(Array(numPeriods), []),
          fundingStream
        );
        const bocTotals =
          _.isEqual(entityType, 'closeoutRecommendation') ||
          _.isEqual(closeoutEntityType, 'closeoutRecommendation')
            ? this.sumBocTotalsCloseout(
                numPeriods,
                bocs,
                itemBocCharges,
                constructionProgramIncome,
                true
              )
            : _.isEqual(entityType, 'closeoutReport') ||
              _.isEqual(closeoutEntityType, 'closeoutReport')
            ? this.sumBocTotalsCloseout(
                numPeriods,
                bocs,
                itemBocCharges,
                constructionProgramIncome,
                true
              )
            : BudgetUtils.sumBocTotals(
                numPeriods,
                bocs,
                itemBocCharges,
                constructionProgramIncome
              );
        const fundingStreamType = _.get(fundingStream, 'fundingStreamType', '');
        let fsTypeUpdate = '';
        if (fundingStreamType === 'indirectExpenses') {
          fsTypeUpdate = 'indirectCosts';
        } else if (fundingStreamType === 'managementCosts') {
          fsTypeUpdate = 'managementAdminCosts';
        } else {
          fsTypeUpdate = fundingStreamType;
        }
        const applicantCostShareBasedOn = _.get(
          fo,
          `configData.costShare.fundingStreams.${fsTypeUpdate}.applicantCostShareBasedOn`
        );
        defaultAppShareRate = this.getRateByType(appShare, fundingStreamType);
        const totalsByPeriod = BudgetUtils.sumChargesByPeriod(
          numPeriods,
          bocTotals,
          bocs
        );
        fedShareArray = [];
        appShareArray = [];
        _.forEach(totalsByPeriod, (total, index) => {
          if (applicantCostShareBasedOn === 'totalProjectCosts') {
            const appVal =
              numPeriods === 1
                ? _.ceil(safeMult(total, defaultAppShareRate[index]), 2)
                : _.round(safeMult(total, defaultAppShareRate[index]), 2);
            appShareArray.push(appVal);
          }
          if (applicantCostShareBasedOn === 'federal') {
            const variable = 1 + defaultAppShareRate[index];
            const appVal =
              numPeriods === 1
                ? _.ceil(
                    safeDivide(safeMult(total, defaultAppShareRate[index]), variable),
                    2
                  )
                : _.round(
                    safeDivide(safeMult(total, defaultAppShareRate[index]), variable),
                    2
                  );
            appShareArray.push(appVal);
          }
        });
        fedShareArray = BudgetUtils.getFedShareByAppShare(totalsByPeriod, appShareArray);
        let costShareObj = {
          fedShare: fedShareArray,
          appShare: appShareArray,
          totals: totalsByPeriod,
          fundingStreamType: fundingStreamType,
        };
        costShareArray.push(costShareObj);
        this.setState(
          {
            costShareSummary: costShareArray,
          },
          () => {
            if (saveUpdatedShare) this.handleBlurDollarCell();
          }
        );
      });
    }
  };

  calcActualTotals = () => {
    const {budget, fundingStreams} = this.props;
    const constructionProgramIncome = _.get(
      budget,
      'nonFederal.constructionProgramIncome'
    );
    let numPeriods = _.get(budget, 'budgetSummary.totalCharges', []).length;
    let totalArrays = [];
    _.forEach(fundingStreams, (fundingStream) => {
      const itemBocCharges = BudgetUtils.collectCosts(
        _.fill(Array(numPeriods), []),
        fundingStream
      );
      const bocTotals = this.sumBocTotalsCloseout(
        numPeriods,
        bocs,
        itemBocCharges,
        constructionProgramIncome
      );
      const totalsByPeriod = BudgetUtils.sumChargesByPeriod(numPeriods, bocTotals, bocs);
      totalArrays.push(totalsByPeriod);
    });

    const result = this.sumArrays(numPeriods, totalArrays);
    return result;
  };

  calcActualAllowedTotals = () => {
    const {budget, fundingStreams} = this.props;
    const constructionProgramIncome = _.get(
      budget,
      'nonFederal.constructionProgramIncome'
    );
    let numPeriods = _.get(budget, 'budgetSummary.totalCharges', []).length;
    let totalArrays = [];
    _.forEach(fundingStreams, (fundingStream) => {
      const itemBocCharges = BudgetUtils.collectCosts(
        _.fill(Array(numPeriods), []),
        fundingStream
      );
      const bocTotals = this.sumBocTotalsCloseout(
        numPeriods,
        bocs,
        itemBocCharges,
        constructionProgramIncome,
        true
      );
      const totalsByPeriod = BudgetUtils.sumChargesByPeriod(numPeriods, bocTotals, bocs);
      totalArrays.push(totalsByPeriod);
    });

    const result = this.sumArrays(numPeriods, totalArrays);
    return result;
  };

  sumArrays = (numPeriods, arrays) => {
    const result = Array(numPeriods).fill(0);
    _.forEach(arrays, (arr) => {
      _.forEach(arr, (val, index) => {
        result[index] = result[index] + val;
      });
    });
    return result;
  };

  sumBocTotalsCloseout = (
    numPeriods,
    bocs,
    totals,
    constructionProgramIncome,
    useActualAllowed
  ) => {
    const initBocTotals = _.reduce(
      bocs,
      (acc, boc) => _.set(acc, boc, _.fill(Array(numPeriods), 0)),
      {}
    );

    const bocTotals = _.reduce(
      totals,
      (acc, periodTotal, period) => {
        _.forEach(periodTotal, (cost) => {
          if (_.includes(bocs, _.get(cost, 'boc'))) {
            const path = `${cost.boc}.${period}`;
            _.set(
              acc,
              path,
              safeAdd(
                _.get(acc, path),
                useActualAllowed
                  ? safeAdd(
                      _.get(cost, ALLOWED_EXCESS_TOTAL),
                      _.get(cost, SCOPE_OF_WORK_TOTAL)
                    )
                  : _.get(cost, ACTUAL_TOTAL)
              )
            );
          }
        });
        return acc;
      },
      initBocTotals
    );

    if (!_.isEmpty(_.get(bocTotals, 'construction')) && constructionProgramIncome) {
      let constructionTotal = safeSubstract(
        _.get(bocTotals, 'construction.0'),
        constructionProgramIncome
      );
      constructionTotal = constructionTotal < 0 ? 0 : constructionTotal;
      bocTotals.construction[0] = constructionTotal;
    }

    return bocTotals;
  };

  handleBlurDollarCell = () => {
    const {
      budget,
      saveEntityData,
      entityType,
      validationId,
      budgetPath,
      closeoutEntityType,
    } = this.props;
    let updatedBudgetShare = _.cloneDeep(budget.share);

    let fedShare = this.state.costShareSummary[0].fedShare.map(function (num) {
      return parseFloat(num);
    });
    let appShare = this.state.costShareSummary[0].appShare.map(function (num) {
      return parseFloat(num);
    });

    if (budget.share.actualAllowedAppShare && budget.share.actualAllowedFedShare) {
      updatedBudgetShare.actualAllowedFedShare = fedShare;
      updatedBudgetShare.actualAllowedAppShare = appShare;
      updatedBudgetShare.totals =
        (_.isEqual(entityType, 'closeoutRecommendation') ||
          _.isEqual(closeoutEntityType, 'closeoutRecommendation')) &&
        _.isEqual(this.state.alternateCostShare, 'Yes')
          ? this.state.costShareSummary[0].totals
          : undefined;
    } else if (budget.share.actualAppShare && budget.share.actualFedShare) {
      updatedBudgetShare.actualFedShare = fedShare;
      updatedBudgetShare.actualAppShare = appShare;
      updatedBudgetShare.totals =
        (_.isEqual(entityType, 'closeoutReport') ||
          _.isEqual(closeoutEntityType, 'closeoutReport')) &&
        _.isEqual(this.state.alternateCostShare, 'Yes')
          ? this.state.costShareSummary[0].totals
          : undefined;
    } else {
      updatedBudgetShare.fedShare = fedShare;
      updatedBudgetShare.appShare = appShare;
      updatedBudgetShare.totals = this.state.costShareSummary[0].totals;
    }

    saveEntityData(
      `${budgetPath}.budget.share`,
      entityType,
      updatedBudgetShare,
      validationId
    );
  };

  handleDollarCellChange = (name, value, idx, index) => {
    let updatedValue = value;
    let updateCostShareSummary = _.cloneDeep(this.state.costShareSummary);
    updateCostShareSummary[idx][name][index] = updatedValue;
    let fedShare = updateCostShareSummary[idx].fedShare[index];
    let appShare = updateCostShareSummary[idx].appShare[index];

    updateCostShareSummary[idx].totals[index] = parseFloat(
      (parseFloat(fedShare) + parseFloat(appShare)).toFixed(2)
    );
    this.setState({
      costShareSummary: updateCostShareSummary,
    });
  };

  renderTableHeader = (numPeriods) => {
    return (
      <FemaGoTable.Header>
        {numPeriods > 1 ? (
          <FemaGoTable.Row>
            <FemaGoTable.HeaderCell textAlign="left">Cost share</FemaGoTable.HeaderCell>
            {_.times(numPeriods, (period) => (
              <FemaGoTable.HeaderCell textAlign="center" colSpan={2}>
                Year {period + 1}
              </FemaGoTable.HeaderCell>
            ))}
            <FemaGoTable.HeaderCell textAlign="right" colSpan={2}>
              Total
            </FemaGoTable.HeaderCell>
          </FemaGoTable.Row>
        ) : (
          <FemaGoTable.Row>
            <FemaGoTable.HeaderCell>Cost share</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>% Percentage</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell textAlign="right" width={2}>
              $ Dollar Amount
            </FemaGoTable.HeaderCell>
          </FemaGoTable.Row>
        )}
      </FemaGoTable.Header>
    );
  };

  renderEditableSection = (paramName, share, idx, index) => {
    return (
      <FemaGoTable.DollarCell
        width={2}
        key={`${paramName}_${idx}_${index}`}
        name={paramName}
        title={paramName}
        value={share ? share : 0}
        displayError={this.displayError(`costShareTotals_${index}`)}
        errorMessages={this.errorMessage(`costShareTotals_${index}`)}
        handleChange={(name, value) => {
          this.handleDollarCellChange(name, value, idx, index);
        }}
        handleBlur={() => this.handleBlurDollarCell()}
      />
    );
  };

  renderCostShareYOYSection = (alternateCostShare, currCostShare, idx) => {
    const {readOnly} = this.props;
    let sources;
    if (this.setFedShareNeeded(alternateCostShare, currCostShare)) {
      sources = [
        {
          label: 'Federal share',
          key: fedShare,
          rate: this.getRateByCalc(fedShare, currCostShare),
        },
        {
          label: 'Non-federal share',
          key: appShare,
          rate: this.getRateByCalc(appShare, currCostShare),
        },
      ];
    } else {
      sources = [
        {
          label: 'Federal share',
          key: fedShare,
          rate: this.getRateByType(fedShare, currCostShare.fundingStreamType),
        },
        {
          label: 'Non-federal share',
          key: appShare,
          rate: this.getRateByType(appShare, currCostShare.fundingStreamType),
        },
      ];
    }

    if (!readOnly && alternateCostShare === 'Yes') {
      return (
        <React.Fragment>
          {_.map(sources, (source) => (
            <FemaGoTable.Row>
              <FemaGoTable.TextCell>Proposed {source.label}</FemaGoTable.TextCell>
              {_.map(currCostShare[source.key], (share, index) => (
                <>
                  <FemaGoTable.TextCell textAlign="center" width={2}>
                    {this.getPercentage(share, currCostShare.totals[index], source.key)}
                  </FemaGoTable.TextCell>
                  {this.renderEditableSection(source.key, share, idx, index)}
                </>
              ))}
              <FemaGoTable.TextCell textAlign="right">
                {showDollarAmountWithDollar(safeAddReduce(currCostShare[source.key]))}
              </FemaGoTable.TextCell>
            </FemaGoTable.Row>
          ))}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {_.map(sources, (source) => (
            <FemaGoTable.Row>
              <FemaGoTable.TextCell>Proposed {source.label}</FemaGoTable.TextCell>
              {_.map(currCostShare[source.key], (share, index) => (
                <>
                  <FemaGoTable.TextCell textAlign="center" width={2}>
                    {_.isEqual(alternateCostShare, 'Yes')
                      ? this.getPercentage(share, currCostShare.totals[index], source.key)
                      : this.convertToPercent(source.rate[index])}
                  </FemaGoTable.TextCell>
                  <FemaGoTable.TextCell textAlign="center" width={2}>
                    {showDollarAmountWithDollar(share)}
                  </FemaGoTable.TextCell>
                </>
              ))}
              <FemaGoTable.TextCell textAlign="right">
                {showDollarAmountWithDollar(safeAddReduce(currCostShare[source.key]))}
              </FemaGoTable.TextCell>
            </FemaGoTable.Row>
          ))}
        </React.Fragment>
      );
    }
  };

  renderCostShareSection = (alternateCostShare, currCostShare, idx) => {
    const {readOnly} = this.props;
    let sources;
    if (this.setFedShareNeeded(alternateCostShare, currCostShare)) {
      sources = [
        {
          label: 'Federal share',
          key: fedShare,
          rate: this.getRateByCalc(fedShare, currCostShare),
        },
        {
          label: 'Non-federal share',
          key: appShare,
          rate: this.getRateByCalc(appShare, currCostShare),
        },
      ];
    } else {
      sources = [
        {
          label: 'Federal share',
          key: fedShare,
          rate: this.getRateByType(fedShare, currCostShare.fundingStreamType),
        },
        {
          label: 'Non-federal share',
          key: appShare,
          rate: this.getRateByType(appShare, currCostShare.fundingStreamType),
        },
      ];
    }

    if (!readOnly && alternateCostShare === 'Yes') {
      return (
        <React.Fragment>
          {_.map(sources, (source) => (
            <FemaGoTable.Row>
              <FemaGoTable.TextCell>Proposed {source.label}</FemaGoTable.TextCell>
              {_.map(currCostShare[source.key], (share, index) => (
                <FemaGoTable.TextCell>
                  {this.getPercentage(share, currCostShare.totals[index], source.key)}
                </FemaGoTable.TextCell>
              ))}
              {_.map(currCostShare[source.key], (share, index) =>
                this.renderEditableSection(source.key, share, idx, index)
              )}
            </FemaGoTable.Row>
          ))}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {_.map(sources, (source) => (
            <FemaGoTable.Row>
              <FemaGoTable.TextCell>Proposed {source.label}</FemaGoTable.TextCell>
              {_.map(currCostShare[source.key], (share, index) => (
                <FemaGoTable.TextCell>
                  {_.isEqual(alternateCostShare, 'Yes')
                    ? this.getPercentage(share, currCostShare.totals[index], source.key)
                    : this.convertToPercent(source.rate[index])}
                </FemaGoTable.TextCell>
              ))}
              {_.map(currCostShare[source.key], (share) => (
                <FemaGoTable.TextCell textAlign="right">
                  {showDollarAmountWithDollar(share)}
                </FemaGoTable.TextCell>
              ))}
            </FemaGoTable.Row>
          ))}
        </React.Fragment>
      );
    }
  };

  renderTotalSection = (numPeriods, totals, alternateCostShare) => {
    const {readOnly} = this.props;
    const align = !readOnly && alternateCostShare === 'Yes' ? 'right' : 'center';

    if (numPeriods > 1) {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell>Total</FemaGoTable.TextCell>
          {_.map(totals, (total) => (
            <>
              <FemaGoTable.TextCell />
              <FemaGoTable.TextCell textAlign={align}>
                {showDollarAmountWithDollar(total)}
              </FemaGoTable.TextCell>
            </>
          ))}
          <FemaGoTable.TextCell textAlign="right">
            {showDollarAmountWithDollar(safeAddReduce(totals))}
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    } else {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell>Total</FemaGoTable.TextCell>
          <FemaGoTable.TextCell />
          <FemaGoTable.TextCell textAlign="right">
            {showDollarAmountWithDollar(safeAddReduce(totals))}
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    }
  };

  renderTableBody = (numPeriods, alternateCostShare, currCostShare, idx) => {
    if (numPeriods > 1) {
      return (
        <FemaGoTable.Body>
          <FemaGoTable.Row>
            <FemaGoTable.TextCell />
            {_.times(numPeriods, (period) => (
              <>
                <FemaGoTable.TextCell textAlign="center" width={2}>
                  {' '}
                  % Percentage
                </FemaGoTable.TextCell>
                <FemaGoTable.TextCell textAlign="center" width={2}>
                  {' '}
                  $ Dollar amount
                </FemaGoTable.TextCell>
              </>
            ))}
            <FemaGoTable.TextCell />
          </FemaGoTable.Row>
          {this.renderCostShareYOYSection(alternateCostShare, currCostShare, idx)}
          {this.renderTotalSection(numPeriods, currCostShare.totals, alternateCostShare)}
        </FemaGoTable.Body>
      );
    } else {
      return (
        <FemaGoTable.Body>
          {this.renderCostShareSection(alternateCostShare, currCostShare, idx)}
          {this.renderTotalSection(numPeriods, currCostShare.totals, alternateCostShare)}
        </FemaGoTable.Body>
      );
    }
  };

  renderOverAll = (numPeriods, alternateCostShare, costShareSummary) => {
    return (
      <React.Fragment>
        <Header as="h4">Cost share for the overall project</Header>
        {_.map(costShareSummary, (currCostShare, idx) => (
          <FemaGoTable summary={'Cost share table'}>
            {this.renderTableHeader(numPeriods)}
            {this.renderTableBody(numPeriods, alternateCostShare, currCostShare, idx)}
          </FemaGoTable>
        ))}
      </React.Fragment>
    );
  };

  renderPerFundingStream = (numPeriods, alternateCostShare, costShareSummary) => {
    return (
      <React.Fragment>
        {_.map(costShareSummary, (currCostShare, idx) => (
          <React.Fragment>
            <Header as="h4">
              Cost share for the{' '}
              {_.get(FUNDING_STREAM_NAME, currCostShare.fundingStreamType, '')}
            </Header>
            <FemaGoTable
              summary={
                'Cost share for the ' +
                _.get(FUNDING_STREAM_NAME, currCostShare.fundingStreamType, '')
              }
            >
              {this.renderTableHeader(numPeriods)}
              {this.renderTableBody(numPeriods, alternateCostShare, currCostShare, idx)}
            </FemaGoTable>
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  };

  getNeedsAttention() {
    const {
      awardRecommendation,
      taskDefKey,
      entityDataPath,
      entityType,
      validationId,
    } = this.props;
    const needsAttention = _.get(awardRecommendation, 'payload.costShare.needsAttention');
    if (needsAttention != false) {
      this.props.saveEntityData(
        `${[entityDataPath]}.needsAttention`,
        entityType,
        false,
        validationId
      );
    }
  }

  render() {
    const {
      fo,
      fundingStreams,
      budget,
      readOnly,
      entityType,
      closeoutEntityType,
      instructionText,
      hideInstructionText,
    } = this.props;
    const sameForAllRecipients = _.get(fo, 'configData.costShare.sameForAllRecipients');
    const sameAcrossFundingStreams = _.get(
      fo,
      'configData.costShare.sameAcrossFundingStreams'
    );
    let numPeriods = _.get(budget, 'budgetSummary.totalCharges', []).length;
    const justificationLabel =
      'Please provide justification for exceeding the allowable federal share here.';
    let grandTotal = safeAddReduce(
      _.map(fundingStreams, (stream) => {
        return calculateChildrenTotalByMode(stream.children, this.props.mode);
      }),
      0
    );

    return (
      <React.Fragment>
        <div>
          {!hideInstructionText && (
            <p>
              {instructionText
                ? instructionText
                : `This is the proposed federal vs. non-federal funding shares based for the
              funding opportunity. You can modify the proposed federal and non-federal share
              for your grant below if you qualify for a cost share that is different than
              the default.`}
            </p>
          )}
          {this.isCloseout(entityType, closeoutEntityType) ? (
            <Header floated="right" as="h4">
              {budget.actualAllowedTotalAmount
                ? 'Actual allowed grand total: ' +
                  showDollarAmountWithDollar(budget.actualAllowedTotalAmount)
                : 'Actual grand total ' +
                  showDollarAmountWithDollar(
                    budget.actualTotalAmount ? budget.actualTotalAmount : grandTotal
                  )}
            </Header>
          ) : (
            <Header floated="right" as="h4">
              Grand total: {showDollarAmountWithDollar(grandTotal)}
            </Header>
          )}
        </div>
        <br />
        {sameForAllRecipients ? (
          <React.Fragment>
            {sameAcrossFundingStreams
              ? this.renderOverAll(
                  numPeriods,
                  this.state.alternateCostShare,
                  this.state.costShareSummary
                )
              : this.renderPerFundingStream(
                  numPeriods,
                  this.state.alternateCostShare,
                  this.state.costShareSummary
                )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Header as="h4">
              Do you qualify for a cost share different than the default{' '}
              {fo ? fo.fundingOpportunityName : ''} cost share?
            </Header>
            {!readOnly ? (
              <RadioField
                name="alternate-costshare"
                id="alternate-costshare"
                value={this.state.alternateCostShare}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'},
                ]}
                checked={this.state.alternateCostShare}
                handleChange={(e) => this.handleAlternateCostShareChange(e)}
                displayError={this.displayError('alternateCostShare')}
                errorMessages={this.errorMessage('alternateCostShare')}
              />
            ) : (
              this.state.alternateCostShare
            )}
            {this.renderOverAll(
              numPeriods,
              this.state.alternateCostShare,
              this.state.costShareSummary
            )}
            {!readOnly && this.state.alternateCostShare === 'Yes' && (
              <React.Fragment>
                <Alert header="Rounded cost share percentages" type="info">
                  Cost share percentages are shown for information purposes only and are
                  rounded to the nearest hundredth of a decimal point based on the dollar
                  amounts inputted.
                </Alert>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={13} className={`noTopPadding`}>
                      <strong>{justificationLabel}</strong>
                      <div className="util--full-width ui form">
                        <TextAreaField
                          rows={4}
                          maxLength={4001}
                          title="justification"
                          label=""
                          id="justification"
                          name="justification"
                          value={this.state.justification}
                          handleChange={(e) => this.handleChangeJustification(e)}
                          handleBlur={() => this.handleJustificationOnBlur()}
                          displayError={this.displayError('justification')}
                          errorMessages={this.errorMessage('justification')}
                        />
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </React.Fragment>
            )}
            {readOnly && this.state.justification && (
              <React.Fragment>
                <br />
                <strong>{justificationLabel}</strong>
                <br />
                {this.state.justification}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
export default connectWithCore(DynamicCostShare);
